import {Button, MenuItem} from '@material-ui/core';
import React, {useState} from 'react';
import Modal from 'Shared/components/Modal';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import './EnrollmentFileRejects.sass';
import {deleteEnrollmentFileRejectError} from 'Enrollment/ducks/enrollmentFileProcessingReject';
import * as O from 'fp-ts/lib/Option';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';

export type EnrollmentFileErrorConfirmationModalProps = {
  onClose: () => void;
  caseRequestId: string;
};

export enum EnrollmentApplicationRemovalOptionType {
  ApplicationRejectionIsTooOldToSend = 1,
  InvalidApplicationRejectionError = 2,
  InternalErrorsOnlyExternalEmailNotRequired = 3,
  EmailSentManuallyOutsideOfEnrollTrack = 4,
}

const EnrollmentApplicationDeleteConfirmationModal = (props: EnrollmentFileErrorConfirmationModalProps) => {
  const {onClose} = props;
  const dispatch = useDispatch();
  const [selectedRemoveOptionId, setSelectedRemoveOptionId] = useState<
    O.Option<EnrollmentApplicationRemovalOptionType>
  >(O.none);

  const {enrollmentFilesRejectFilter} = useSelector((state: ReducerState) => state.enrollmentFileProcessingReject);

  const handleEnrollmentFileRejectOptionChange = (value: EnrollmentApplicationRemovalOptionType) => {
    setSelectedRemoveOptionId(O.some(value));
  };

  const disableDeleteButton = O.isNone(selectedRemoveOptionId);

  const handleDeleteEnrollmentApplication = () => {
    if (O.isSome(selectedRemoveOptionId)) {
      dispatch(
        deleteEnrollmentFileRejectError(props.caseRequestId, enrollmentFilesRejectFilter, selectedRemoveOptionId.value)
      );
    }
    onClose();
  };

  return (
    <Modal open onClose={onClose} title="Delete Confirmation">
      <div className="enrollment-file-rejects-modal">
        <h4>Are you sure you would like to delete this application?</h4>

        <OutlinedSelect
          className="enrollment-file-rejects-modal__remove-content-Options"
          label="Reason for Delete"
          onChange={e =>
            handleEnrollmentFileRejectOptionChange(
              parseInt(e.target.value, 10) as EnrollmentApplicationRemovalOptionType
            )
          }
          value={O.isSome(selectedRemoveOptionId) ? selectedRemoveOptionId.value : ''}
        >
          <MenuItem value={EnrollmentApplicationRemovalOptionType.ApplicationRejectionIsTooOldToSend}>
            Error Is Too Old To Send
          </MenuItem>
          <MenuItem value={EnrollmentApplicationRemovalOptionType.InvalidApplicationRejectionError}>
            Invalid Error
          </MenuItem>
          <MenuItem value={EnrollmentApplicationRemovalOptionType.InternalErrorsOnlyExternalEmailNotRequired}>
            Internal Errors Only, External Email Not Required
          </MenuItem>
          <MenuItem value={EnrollmentApplicationRemovalOptionType.EmailSentManuallyOutsideOfEnrollTrack}>
            Email Sent Manually Outside Of Enroll Track
          </MenuItem>
        </OutlinedSelect>

        <div className="modal__footer modal__footer-enrollment-file-rejects">
          <Button className="modal__footer-enrollment-file-rejects-actions" variant="contained" onClick={onClose}>
            Close
          </Button>
          <Button
            className="modal__footer-enrollment-file-rejects-actions"
            color="primary"
            variant="contained"
            disabled={disableDeleteButton}
            onClick={handleDeleteEnrollmentApplication}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EnrollmentApplicationDeleteConfirmationModal;
